export default {
  'menu.workbench': 'workbench',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.permissions': 'Permissions',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.task': 'Task Management',
  'menu.task.dashboard': 'Dashboard',
  'menu.task.today': 'Today',
  'menu.task.assignee': 'Assigned to Me',
  'menu.task.week': 'This Week',
  'menu.task.next7days': 'Next 7 Days',
  'menu.task.all': 'All Tasks',
  'menu.task.create': 'Created by Me',
  'menu.task.assigner': 'Assigned by Me',
  'menu.task.watched': 'Watched by Me',
  'menu.task.completed': 'Completed',
  'menu.task.recycle': 'Recycle Bin',
  'menu.task.search': 'Search',
  'menu.task.active': 'Activities',
  'menu.task.report': 'Daily Report',
  'menu.task.screenAll': 'All Boards',
  'menu.task.screenDetail': 'Board Detail',
  'menu.task.tasklists': 'Task Lists',
  'menu.task.tasklistDetail': 'Task List Detail',
  'menu.task.tags': 'Tags',
  'menu.task.tagDetail': 'Tag Detail',
  'menu.task.settings': 'Task Settings',
  'menu.task.settings.settingsNotification': 'Notification Settings',
  'menu.task.settings.settingsRoles': 'Role Settings',
  'menu.task.settings.settingsPermissions': 'Permission Settings',
  'menu.task.appConfig': 'App Config',
  'menu.task.appConfigMenu': 'Menu Config',
  'menu.task.appConfigUpload': 'Upload Config',
  'menu.task.task.dashboard': 'Dashboard',
  'menu.task.task.today': 'Today',
  'menu.task.task.assignee': 'Assigned to Me',
  'menu.task.task.week': 'This Week',
  'menu.task.task.next7days': 'Next 7 Days',
  'menu.task.task.all': 'All Tasks',
  'menu.task.task.create': 'Created by Me',
  'menu.task.task.assigner': 'Assigned by Me',
  'menu.task.task.watched': 'Watched by Me',
  'menu.task.task.completed': 'Completed',
  'menu.task.task.recycle': 'Recycle Bin',
  'menu.task.task.search': 'Search',
  'menu.task.task.active': 'Activities',
  'menu.task.task.report': 'Daily Report',
  'menu.task.task.screenAll': 'All Boards',
  'menu.task.task.screenDetail': 'Board Detail',
  'menu.task.task.tasklists': 'Task Lists',
  'menu.task.task.tasklistDetail': 'Task List Detail',
  'menu.task.task.tags': 'Tags',
  'menu.task.task.tagDetail': 'Tag Detail',
  'menu.task.task.appConfig': 'App Config',
  'menu.task.appConfig.appConfigMenu': 'Menu Config',
  'menu.task.appConfig.appConfigUpload': 'Upload Config',
  'menu.task.task.appConfig.task.appConfigMenu': 'Menu Config',
  'menu.task.task.appConfig.task.appConfigUpload': 'Upload Config',
};
